<div class="dialog-content">
  <div class="notice-container">
    <img
      [src]="this.imagePath + '/' + data.notice?.image_url"
      alt="Notice Image"
      class="notice-image"
    />
  </div>

  <div class="notice-details">
    <h2 class="notice-title">{{ data.notice?.heading }}</h2>
    <p class="notice-description">{{ data.notice?.description }}</p>
    <div class="notice-status">
      <p>
        <strong translate>Active From:</strong>
        {{ data.notice?.visible_from | date : "dd/MM/yyyy" }}
      </p>
      <p>
        <strong translate>Active Till:</strong>
        {{ data.notice?.visible_until | date : "dd/MM/yyyy" }}
      </p>
      <p>
        <strong translate>Status:</strong>
        <span
          [ngClass]="{
            'status-active': data.notice?.status === 'Active',
            'status-inactive': data.notice?.status !== 'Active'
          }"
        >
          {{ data.notice?.status }}
        </span>
      </p>
    </div>
  </div>

  <div class="dialog-actions">
    <button translate mat-stroked-button class="cancel_button" (click)="closeDialog()">
      Cancel
    </button>
    <button translate mat-raised-button color="primary" (click)="editNotice()">
      Edit
    </button>
    <button translate mat-raised-button color="warn" (click)="deleteNotice()">
      Delete
    </button>
  </div>
</div>
